import React, { useEffect, useState } from 'react';
import Styles from './PortraitModeGuard.module.scss';

// Phone landscape: width exceeds 767px on modern devices (e.g. iPhone 12 Pro = 844px),
// so use short viewport height + touch instead of max-width.
const MOBILE_LANDSCAPE_QUERY =
  '(orientation: landscape) and (hover: none) and (pointer: coarse) and (max-height: 500px)';

const PortraitModeGuard: React.FC = () => {
  const [showOverlay, setShowOverlay] = useState(() =>
    window.matchMedia(MOBILE_LANDSCAPE_QUERY).matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_LANDSCAPE_QUERY);
    const updateOverlay = () => setShowOverlay(mediaQuery.matches);

    updateOverlay();
    mediaQuery.addEventListener('change', updateOverlay);
    window.addEventListener('orientationchange', updateOverlay);
    window.addEventListener('resize', updateOverlay);

    return () => {
      mediaQuery.removeEventListener('change', updateOverlay);
      window.removeEventListener('orientationchange', updateOverlay);
      window.removeEventListener('resize', updateOverlay);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = showOverlay ? 'hidden' : '';

    return () => {
      document.body.style.overflow = '';
    };
  }, [showOverlay]);

  if (!showOverlay) {
    return null;
  }

  return (
    <div
      className={`${Styles.overlay} ${Styles.visible}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="portrait-mode-title"
    >
      <svg
        className={Styles.icon}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        aria-hidden="true"
      >
        <rect x="7" y="2" width="10" height="20" rx="2" />
        <path d="M11 18h2" strokeLinecap="round" />
      </svg>
      <h2 id="portrait-mode-title" className={Styles.title}>
        Please rotate your device
      </h2>
      <p className={Styles.subtitle}>
        Moderate Politics works best in portrait mode on mobile.
      </p>
    </div>
  );
};

export default PortraitModeGuard;
